module.exports = __webpack_public_path__ + "static/src/content/silks/nature_strip.20ac083.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/silks/nature_strip.png
// module id = LD95
// module chunks = 0